module.exports = ".mat-dialog-content {\n    min-width: 350px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/resetadminblockdialog/resetadminblockdialog.component.css
// module id = ./src/app/resetadminblockdialog/resetadminblockdialog.component.css
// module chunks = main